import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const METRICS_ENABLED = process.env.REACT_APP_PRODUCT_METRICS_DISABLED !== "true";

export const trackProductEvent = (eventName, properties = {}, getAuthHeaders) => {
  if (!METRICS_ENABLED || typeof getAuthHeaders !== "function") return;

  axios
    .post(
      `${API_URL}/product-metrics/events`,
      {
        event_name: eventName,
        properties,
      },
      { headers: getAuthHeaders() }
    )
    .catch(() => {
      // Metrics are non-critical: never block UX or playback because telemetry failed.
    });
};
